<div [formGroup]="filterForm" class="form-content">
  <div class="pure-g">
    <!-- Row 1: Repair Code - Description + Mode -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-multi-select
        ngDefaultControl
        label="Repair Code - Description"
        fit="medium"
        placeholder="Select repair codes"
        formControlName="RepairCodeList">
        @for (code of repairCodeOptions; track code.key) {
          <mc-option [value]="code.key">{{ code.key }} - {{ code.value }}</mc-option>
        }
      </mc-multi-select>
    </div>

    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-multi-select ngDefaultControl label="Mode" fit="medium" placeholder="Select modes" formControlName="RepairModeList">
        @for (mode of modeOptions; track mode) {
          <mc-option [value]="mode">{{ mode }}</mc-option>
        }
      </mc-multi-select>
    </div>

    <!-- Row 2: Grades Applicable + Generate grade change -->
    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-multi-select
        ngDefaultControl
        label="Grades applicable"
        fit="medium"
        placeholder="Nothing selected"
        formControlName="GradesApplicableList">
        @for (grade of gradeOptions; track grade) {
          <mc-option [value]="grade">{{ grade }}</mc-option>
        }
      </mc-multi-select>
      <span class="helper-text">Select all grades applicable to the repair code.</span>
    </div>

    <div class="pure-u-1 pure-u-md-1-2 p-r-8 p-b-16">
      <mc-radio-group
        ngDefaultControl
        name="GenerateGradeChange"
        legend="Generate grade change"
        fit="medium"
        orientation="horizontal"
        formControlName="GenerateGradeChange">
        <mc-radio name="GenerateGradeChange" value="yes" label="Yes"></mc-radio>
        <mc-radio name="GenerateGradeChange" value="no" label="No"></mc-radio>
      </mc-radio-group>
    </div>
  </div>
</div>

<div class="utility-buttons">
  <mc-button
    label="Apply filters"
    variant="filled"
    appearance="primary"
    fit="medium"
    (click)="applyFilters()"
    (keydown.enter)="applyFilters()">
  </mc-button>
  <mc-button
    label="Clear filters"
    variant="outlined"
    appearance="neutral"
    fit="medium"
    class="m-r-8"
    (click)="clearFilters()"
    (keydown.enter)="clearFilters()">
  </mc-button>
</div>
